<template>
    <div v-if="user" class="p-3">
        <h2 class="text-center">SELAMAT DATANG DI PORTAL PENDAFTARAN</h2>
        <h4 class="text-center">Anda Sedang Berada Di Halaman Konfigurasi Pendaftaran Online</h4>

        <div class="row">
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI METODE PENDAFTARAN"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Metode Pendaftaran dan Loket Pendaftaran.
                        </b-card-text>
                        <b-link to="/konfigurasi-loket-pendaftaran-online" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="WEBSITE"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Halaman Portal Website Pendaftaran Online
                        </b-card-text>
                        <b-link to="/konfigurasi-website" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI USER"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi User Website Pendaftaran Online
                        </b-card-text>
                        <b-link to="/konfigurasi-user" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI KUOTA POLI"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Kuota Pendaftaran Per Poli
                        </b-card-text>
                        <b-link to="/konfigurasi-kuota-poli" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI KATEGORI"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Kategori Antrean.
                        </b-card-text>
                        <b-link to="/konfigurasi-kategori-antrean" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI MASTER LOKET"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Master Loket.
                        </b-card-text>
                        <b-link to="/konfigurasi-master-loket" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="KONFIGURASI MASTER LOKET PENDAFTARAN"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Konfigurasi Master Loket Pendaftaran.
                        </b-card-text>
                        <b-link to="/konfigurasi-loket-pendaftaran" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-grid gap2 col-4 mt-5 mx-auto">
                <b-card-group deck>
                    <b-card
                        header="PENGUMUMAN"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-text>
                            Pengaturan Pengumuman.
                        </b-card-text>
                        <b-link to="/konfigurasi-pengumuman" class="btn btn-success mt-3">Lihat Lebih Lengkap <b-icon icon="arrow-right"></b-icon></b-link>
                    </b-card>
                </b-card-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null,
            access_token: null,
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')
        },
    }
}
</script>
